export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxbl8c6SjTjQJElg.2c2022d7.woff2";